<template>
	<div class="refundOrder-body">
		<div class="shop-position">
			<img src="~/images/icon/position-icon.png">
			当前卖家店铺：
			<el-select size="mini" v-model="sellerShopId" placeholder="请选择" @change="shopChange">
				<el-option value="0" label="全部"></el-option>
				<el-option
					v-for="item in shopOptions"
					:key="item.id"
					:label="item.name"
					:value="item.id"/>
				</el-select>
		</div>
		<ul class="refundOrder-menu">
			<li
				v-for="item in refundOrderMenu"
				:key="item.name"
				v-show='item.show'
				:class="{ active : active === item.name }"
				@click="refundOrderMenuSwitch(item)"
			>{{item.name}}</li>
			<div class="menu-right">
				<label for="refund-order-file" style="line-height: 30px;">
					<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" @click="importExcel">批量导入</el-button>
				</label>
				<input type="file" ref="file" id="refund-order-file" v-show="false" @change="getFile">
				<a href="javascript:void(0);" @click="downloadFile" class="batch-register-btn">
					<i class="excel-icon export-excel-icon"/>
					<span>导入模板下载</span>
				</a>
				<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" icon="el-icon-printer" @click="printerEvent">打印</el-button>
				<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" v-if="AuthorityList['07_0006_0001_00']" @click="goRefundValet">
					代客退单
				</el-button>
				<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" v-if="AuthorityList['07_0003_0001_00']" @click="goValet">
					代客下单
				</el-button>
				<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" v-if="AuthorityList['07_0002_0017_00']" @click="exportExcel">
					<div></div>
					导出
				</el-button>
			</div>
		</ul>
		<Search :active="active" :customList="customList" :overrefunddock='overrefunddock' :clddock="clddock" :origin="origin" :orderno='orderno' ref='searchRef' @handleSearch="handleSearch"/>
		<MainTable
			ref='table'
			:clddock="clddock"
			:overrefunddock='overrefunddock'
			:totalCount='totalCount'
			:active='active'
			:orderSort='orderSort'
			:size='size'
			:page='page'
			:tableData='tableData'
			@idsChange='idsChange'
			@saveSelect='saveSelect'
			@sortList='sortList'
			@handleSize='handleSizeChange'
			@tableReload='tableReload'
			@handlePage='handlePageChange'
		/>
		<el-dialog
			title="打印设置"
			:visible.sync="printerVisible"
			class="dialog-title"
			width="530px">
				<Print :ids="ids" :templateType="1" v-if="printerVisible"/>
		</el-dialog>
		<el-dialog title="提示" class="dialog-title" :visible.sync="tipModal" width="400px" :close-on-click-modal="false">
			<div style="padding-bottom:20px;text-align: left;overflow:auto" v-for="item in tipData" :key="item">
				{{item}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Search from '@/components/refundOrder/Search.vue'
import MainTable from '@/components/refundOrder/MainTable.vue'
import Print from '@/components/print/Print.vue'
export default {
	name: 'refundOrder',
	components: {
		Search,
		MainTable,
		Print
	},
	data () {
		return {
			shopOptions: [],
			sellerShopId: '0',
			refundOrderMenu: [
				{ name: '全部退单', show: true },
				{ name: '待处理', orderStatus: '0', show: false },
				{ name: '已同意', orderStatus: '1', show: false },
				{ name: '已拒绝', orderStatus: '2', show: false },
				{ name: '退货完成', orderStatus: '3', show: false }
				// { name: '退货处理', orderStatus: '4', show: false }
				// { name: '仲裁中', orderStatus: '4', show: false }
			],
			active: '全部退单',
			dateValue: [],
			buyerTel: '',
			refundOrderNumber: '',
			orderNumber: '',
			paymentMode: '-1',
			payStatus: -1,
			liquidateflag: '-1',
			pushstate: -1,
			buyerName: '',
			orderStatus: 0,
			page: 1,
			size: 20,
			tableData: [],
			refundNumber: '',
			cause: -1,
			totalCount: 0,
			clddock: 0,
			overrefunddock: 0,
			origin: '',
			excelParams: {},
			customList: [],
			customerCategoryId: '0',
			customerName: '',
			sourcetype: -1,
			autorefundflag: -1,
			address: '',
			orderSort: '',
			orderno: '',
			AuthorityList: {
				'07_0003_0001_00': false
			},
			printerVisible: false,
			tipData: [],
			tipModal: false,
			ids: [],
			productName: '',
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		this.getAuthority('07_0002_0000_00')
		this.getAuthority2('07_0002_0000_00,07_0003_0000_00')
		this.$fxEventBus.$emit('setMenu', '6-2')
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		this.getCategory()
		this.openPage()
	},
	mounted () {
		window.addEventListener('message', this.receiveMessage)
	},
	beforeDestroy () {
		window.removeEventListener('message', this.receiveMessage)
	},
	methods: {
		openPage () {
			if (window.sessionStorage.getItem('refundOrderSelect') && !this.filterFlag) {
				let data = JSON.parse(window.sessionStorage.getItem('refundOrderSelect'))
				this.dateValue = data.dateValue
				this.buyerTel = data.buyerTel
				this.refundOrderNumber = data.refundOrderNumber
				this.orderNumber = data.orderNumber
				this.paymentMode = data.paymentMode
				this.payStatus = data.payStatus
				this.buyerName = data.buyerName
				this.refundNumber = data.refundNumber
				this.cause = data.cause
				this.pushstate = data.pushstate
				this.liquidateflag = data.liquidateflag
				this.customerCategoryId = data.customerCategoryId
				this.customerName = data.customerName
				this.sourcetype = data.sourcetype
				this.autorefundflag = data.autorefundflag
				this.address = data.address
				this.productName = data.productName
				this.page = data.page
				this.size = data.size
				this.excelParams = {
					beginDate: window.sessionStorage.getItem('startDate') && !this.filterFlag ? window.sessionStorage.getItem('startDate') : data.dateValue.length > 0 ? data.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
					endDate: window.sessionStorage.getItem('endDate') && !this.filterFlag ? window.sessionStorage.getItem('endDate') : data.dateValue.length > 0 ? data.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
					orderNumber: data.orderNumber,
					refundNumber: data.refundNumber,
					buyerName: data.buyerName,
					buyerTel: data.buyerTel,
					pushstate: data.pushstate,
					paymentMode: data.paymentMode,
					payStatus: data.payStatus,
					cause: data.cause,
					liquidateflag: data.liquidateflag,
					customerCategoryId: data.customerCategoryId,
					customerName: data.customerName,
					sourcetype: data.sourcetype,
					autorefundflag: data.autorefundflag,
					address: data.address,
					productName: data.productName
				}
			} else {
				this.excelParams = {
					beginDate: window.sessionStorage.getItem('startDate') && !this.filterFlag ? window.sessionStorage.getItem('startDate') : this.dateValue.length > 0 ? this.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
					endDate: window.sessionStorage.getItem('endDate') && !this.filterFlag ? window.sessionStorage.getItem('endDate') : this.dateValue.length > 0 ? this.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
					orderNumber: this.orderNumber,
					refundNumber: this.refundNumber,
					buyerName: this.buyerName,
					buyerTel: this.buyerTel,
					pushstate: this.pushstate,
					paymentMode: this.paymentMode,
					payStatus: this.payStatus,
					cause: this.cause,
					liquidateflag: this.liquidateflag,
					customerCategoryId: this.customerCategoryId,
					customerName: this.customerName,
					sourcetype: this.sourcetype,
					autorefundflag: this.autorefundflag,
					address: this.address,
					productName: this.productName
				}
			}
			let a = JSON.parse(window.sessionStorage.getItem('refundTab'))
			if (a) {
				if (!a.origin) {
					this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
				} else {
					this.origin = a.origin
				}
				let c = window.sessionStorage.getItem('startDate')
				let b = window.sessionStorage.getItem('endDate')
				if (c && !this.filterFlag) {
					this.dateValue = [c, b]
				}
				this.findShopList().then((data) => {
					this.shopOptions = data
					this.sellerShopId = a.shopId || '0'
					this.active = a.active
					this.orderStatus = a.orderStatus
					if (this.$route.query.ordernumber) {
						this.orderNumber = this.$route.query.ordernumber
						this.excelParams.orderNumber = this.$route.query.ordernumber
						this.orderno = this.$route.query.ordernumber
						this.active = '待处理'
						this.orderStatus = '0'
						this.dateValue[0] = this.$route.query.date.substring(0, 16)
					}
					this.findrefundOrderList()
				})
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
				let c = window.sessionStorage.getItem('startDate')
				let b = window.sessionStorage.getItem('endDate')
				if (c && !this.filterFlag) {
					this.dateValue = [c, b]
				}
				this.findShopList().then((data) => {
					if (data.length > 0) {
						this.sellerShopId = '0'
						this.shopOptions = data
						if (this.$route.query.ordernumber) {
							this.orderNumber = this.$route.query.ordernumber
							this.excelParams.orderNumber = this.$route.query.ordernumber
							this.orderno = this.$route.query.ordernumber
							this.active = '待处理'
							this.orderStatus = '0'
							this.dateValue[0] = this.$route.query.date.substring(0, 16)
						}
						this.findrefundOrderList()
					}
				})
			}
		},
		receiveMessage (e) {
			console.log(e, 'receiveMessage')
			const res = e.data
			if (res.tabRefresh) {
				this.tableReload()
			}
		},
		idsChange (ids) {
			this.ids = ids
		},
		printerEvent () {
			if (this.ids.length < 1) {
				this.$message.error('请至少选择一条退单！')
				return false
			}
			this.printerVisible = true
			// this.$emit('openPrinter')
		},
		saveSelect () {
			if (!this.filterFlag) {
				let params = {
					dateValue: this.dateValue,
					buyerTel: this.buyerTel,
					refundOrderNumber: this.refundOrderNumber,
					orderNumber: this.orderNumber,
					paymentMode: this.paymentMode,
					payStatus: this.payStatus,
					buyerName: this.buyerName,
					refundNumber: this.refundNumber,
					cause: this.cause,
					pushstate: this.pushstate,
					liquidateflag: this.liquidateflag,
					customerCategoryId: this.customerCategoryId,
					customerName: this.customerName,
					sourcetype: this.sourcetype,
					autorefundflag: this.autorefundflag,
					address: this.address,
					productName: this.productName,
					page: this.page,
					size: this.size
				}
				window.sessionStorage.setItem('refundOrderSelect', JSON.stringify(params))
			}
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						switch (a[i]) {
						case '07_0002_0001_00':
							this.refundOrderMenu[1].show = true
							break
						case '07_0002_0007_00':
							this.refundOrderMenu[2].show = true
							break
						case '07_0002_0010_00':
							this.refundOrderMenu[3].show = true
							break
						case '07_0002_0013_00':
							this.refundOrderMenu[4].show = true
							break
						}
					}
				}
			})
		},
		getAuthority2 (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		sortList (value) {
			this.orderSort = value
			this.findrefundOrderList()
		},
		tableReload () {
			this.findrefundOrderList()
		},
		shopChange () {
			this.findrefundOrderList()
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/selectOrganList`
				}).then(res => {
					resolve(res[0].shopInfoList)
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		findrefundOrderList () {
			this.tableData = []
			let a = { orderStatus: this.orderStatus, active: this.active, shopId: this.sellerShopId }
			window.sessionStorage.setItem('refundTab', JSON.stringify(a))
			let params = {
				ifBuyer: false,
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : '',
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : '',
				orderNumber: this.orderNumber,
				refundNumber: this.refundNumber,
				// pushstate: this.pushstate,
				buyerName: this.buyerName,
				buyerTel: this.buyerTel,
				paymentMode: +this.paymentMode,
				payStatus: +this.payStatus,
				liquidateflag: this.liquidateflag,
				cause: this.cause,
				customerCategoryId: this.customerCategoryId,
				customerName: this.customerName,
				autorefundflag: this.autorefundflag,
				address: this.address,
				page: this.page,
				size: this.size,
				sellerShopId: this.sellerShopId,
				orderby: this.orderSort !== '' ? 'billState' : '',
				orderSort: this.orderSort,
				paymentnumber: this.paymentnumber ? this.paymentnumber : null,
				paymentserialnumber: this.paymentserialnumber ? this.paymentserialnumber : null,
				productName: this.productName
			}
			if (this.sourcetype !== -1) {
				params.sourcetype = this.sourcetype
			}
			if (this.sourcetype === 22) {
				params.sourcetype = 2
				params.pushstate = 3
			}
			if (this.active !== '全部退单') {
				params.orderStatus = this.orderStatus
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/refundorder/findlist`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				this.clddock = res.clddock
				this.overrefunddock = res.overrefunddock
				if (res.recordList !== null) {
					res.recordList.forEach(item => {
						item.checked = false
						item.orderprice = this.$fxUtils.toFixedSHW(item.orderprice, 2)
						item.sumrefundmoney = this.$fxUtils.toFixedSHW(item.sumrefundmoney, 2)
						item.numberArray = []
						item.serialArray = []
						if (item.paymentnumber) {
							item.paymentnumber.forEach(item2 => {
								if (item.paymentnumber.length > 0) {
									item.numberArray.push(item2.paymentnumber)
									item.serialArray.push(item2.paymentserialnumber)
								} else {
									item.numberArray = []
									item.serialArray = []
								}
							})
							if (item.numberArray) {
								item.paymentnumber = item.numberArray[0]
							} else {
								item.paymentnumber = ''
							}
							if (item.serialArray) {
								item.paymentserialnumber = item.serialArray[0]
							} else {
								item.paymentserialnumber = ''
							}
						}
						switch (item.cause) {
						case 0:
							item.cause = '无理由退换'
							break
						case 1:
							item.cause = '质量问题'
							break
						case 2:
							item.cause = '与商品描述不符合 '
							break
						case 3:
							item.cause = '卖家发错货'
							break
						case 4:
							item.cause = '发票问题'
							break
						case 5:
							item.cause = '其他'
							break
						}
						switch (item.autorefundflag) {
						case 0:
							item.autorefundflag = '手动退单'
							break
						case 1:
							item.autorefundflag = '自动退单'
							break
						}
						switch (item.cancelCause) {
						case 1:
							item.cancelCause = '质量无问题'
							break
						case 2:
							item.cancelCause = '超出退货时间 '
							break
						case 3:
							item.cancelCause = '问题已解决'
							break
						case 4:
							item.cancelCause = '该商品不符合无理由退货'
							break
						case 5:
							item.cancelCause = '影响二次销售'
							break
						case 6:
							item.cancelCause = '其他原因'
							break
						}
						switch (item.paymentmode) {
						case '0':
							item.paymentmode = '线下'
							break
						case '1':
							item.paymentmode = '商龙钱包'
							break
						case '2':
							item.paymentmode = '微信支付'
							break
						case '3':
							item.paymentmode = '支付宝'
							break
						case '4':
							item.paymentmode = '预付货款'
							break
						case '6':
							item.paymentmode = '微企付'
							break
						case '7':
							item.paymentmode = '云资金-网商余额支付'
							break
						case '8':
							item.paymentmode = '云资金-汇付支付'
							break
						case '9':
							item.paymentmode = '云资金-中信支付'
							break
						case '10':
							item.paymentmode = '云资金-富友账户通支付'
							break
						case '11':
							item.paymentmode = 'B2b门店助手-微信支付'
							break
						case '12':
							item.paymentmode = 'B2b门店助手-银行转账'
							break
						case '13':
							item.paymentmode = '云资金-网商收银台'
							break
						case '14':
							item.paymentmode = '拉卡拉全渠道-余额支付'
							break
						case '15':
							item.paymentmode = '拉卡拉全渠道-收银台'
							break
						case '16':
							item.paymentmode = '拉卡拉钱包余额'
							break
						}
					})
					this.tableData = res.recordList
					this.$nextTick(() => {
						this.$refs.table.initTableData()
					})
				}
			})
		},
		changeName (data) {
			switch (data) {
			case '0':
				this.active = '待处理'
				break
			case '1':
				this.active = '已同意'
				break
			case '2':
				this.active = '已拒绝'
				break
			case '3':
				this.active = '退货完成'
				break
			case '4':
				this.active = '仲裁中'
				break
			default:
				this.active = '全部退单'
				break
			}
		},
		refundOrderMenuSwitch (data) {
			this.$refs.table.clear()
			this.orderStatus = data.orderStatus
			this.changeName(this.orderStatus)
			// this.$refs.searchRef.clearInput()
			this.$refs.searchRef.search()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			// this.$refs.searchRef.clearInput()
			this.findrefundOrderList()
		},
		handlePageChange (value) {
			this.page = value
			// this.$refs.searchRef.clearInput()
			this.findrefundOrderList()
		},
		handleSearch (data) {
			this.$refs.table.clear()
			this.dateValue = data.dateValue
			this.buyerTel = data.buyerTel
			this.refundOrderNumber = data.refundOrderNumber
			this.orderNumber = data.orderNumber
			this.paymentMode = data.paymentMode
			this.payStatus = data.payStatus
			this.buyerName = data.buyerName
			this.refundNumber = data.refundNumber
			this.liquidateflag = data.liquidateflag
			this.customerCategoryId = data.customerCategoryId
			this.customerName = data.customerName
			this.sourcetype = data.sourcetype
			this.autorefundflag = data.autorefundflag
			this.address = data.address
			this.orderSort = ''
			this.cause = data.cause
			this.pushstate = data.pushstate
			this.page = 1
			this.$refs.table.pagination.page = 1
			this.paymentnumber = data.paymentnumber
			this.paymentserialnumber = data.paymentserialnumber
			this.productName = data.productName
			this.excelParams = {
				beginDate: window.sessionStorage.getItem('startDate') && !this.filterFlag ? window.sessionStorage.getItem('startDate') : data.dateValue.length > 0 ? data.dateValue[0] : '',
				endDate: window.sessionStorage.getItem('endDate') && !this.filterFlag ? window.sessionStorage.getItem('endDate') : data.dateValue.length > 0 ? data.dateValue[1] : '',
				orderNumber: data.orderNumber,
				refundNumber: data.refundNumber,
				buyerName: data.buyerName,
				buyerTel: data.buyerTel,
				pushstate: data.pushstate,
				paymentMode: +data.paymentMode,
				payStatus: +data.payStatus,
				cause: data.cause,
				liquidateflag: data.liquidateflag,
				customerCategoryId: data.customerCategoryId,
				customerName: data.customerName,
				sourcetype: data.sourcetype,
				autorefundflag: data.autorefundflag,
				address: data.address,
				productName: data.productName
			}
			this.findrefundOrderList()
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/refundorder/refundorderList/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			this.excelParams.ifBuyer = false
			// this.excelParams.isSellerpull = this.isSellerpull
			this.excelParams.sellerShopId = this.sellerShopId
			if (this.excelParams.sourcetype === -1) {
				this.excelParams.sourcetype = null
			}
			if (this.active !== '全部退单') {
				this.excelParams.orderStatus = this.orderStatus
			}
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			let name = this.active === '全部退单' ? '全部 - 退单详情(' + year + month + day + hour + min + ').xls' : this.active + ' - 退单详情(' + year + month + day + hour + min + ').xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		downloadFile () {
			let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/biubiuorder/refundOrder/template/批量代客退单导入模版.xlsx?timeStamp=' + new Date().getTime()
			window.location.href = url
		},
		importExcel () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		getFile () {
			this.uploadGoodsHandle()
		},
		uploadGoodsHandle () {
			var formData = new FormData()
			formData.append('file', this.$refs.file.files[0])
			this.$store.dispatch('requestFilePost', {
				url: `${this.$fxBaseApi.newExportUrl}/refundorder/importBatchRefundOrder`,
				data: formData
			}).then(res => {
				this.$refs.file.value = ''
				if (res.result) {
					this.$message.success(res.msg || '导入成功！')
					this.tableReload()
				} else {
					this.tipData = res.data
					this.tipModal = true
				}
			}).catch(() => {
				this.$refs.file.value = ''
			})
		},
		goValet () {
			let app = window.sessionStorage.getItem('app')
			if (app === 'scm8') {
				let params = {
					app: 'jsd',
					action: 'goBlank',
					data: {
						path: 'main/valetOrder',
						title: '代客下单',
						biubiuorderId: 'valetOrder',
						biubiuorderMenuId: 'valetOrder'
					}
				}
				window.parent.postMessage(params, '*')
			} else {
				this.$router.push(`/main/valetOrder`)
			}
		},
		goRefundValet () {
			this.$router.push(`/main/valetRefundOrder`)
		}
	}
}
</script>

<style lang="stylus" scoped>
.refundOrder-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.refundOrder-menu {
		height: 50px
		display flex
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 55px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				color: #f85050
				position: absolute
				right: -33px
			}
		}
	}
}
</style>
<style lang="stylus">
	.menu-right {
		margin-left: auto;
		height: 100%;
		display: flex;
		align-items: center
		.batch-register-btn {
			cursor: pointer;
			color: #409EFF;
			font-size: 12px;
			margin: 0 10px;
			height: 32px;
			display: flex;
			align-items: center;
		}
		.excel-icon {
			display: inline-block;
			height: 20px;
			width: 20px;
			background-repeat: no-repeat;
			background-position: center;
			margin-right: 2px;
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
		.export-btn {
			span {
				display: flex;
				align-items: center
				div {
					width: 14px;
					height: 14px;
					margin-right: 5px;
					background-image: url('~images/icon/export-icon.png')
				}
			}
			&:hover {
				div {
					background-image: url('~images/icon/export-white-icon.png')
				}
			}
		}
	}
	.refundOrder-body {
		.dialog-title {
			text-align: left
			.el-dialog__headerbtn{
				width: 20px;
				height: 20px;
				border-radius: 50%;
				background-color: red;
				line-height: 20px;
				font-weight:blod;
				.el-icon-close{
					color:#fff
				}
			}
		}
		.el-dialog__footer{
			text-align :center
		}
	}
</style>
